import { useState, useCallback, useEffect } from "react";
import AxiosClient from "../../../Network/AxiosClient";

const ROLE_API_MAPPING = {
  cluster_head: "/organizations/api/v1/clusters",
  regional_manager: "/organizations/api/v1/regions",
  area_manager: "/organizations/api/v1/areas",
  territory_manager: "/organizations/api/v1/territories",
  agency_user: "/organizations/api/v1/agency",
};

export const useAssignmentSearch = (userType) => {
  const [assignedToOptions, setAssignedToOptions] = useState([
    { label: "Select Assignment", value: "", isPlaceholder: true },
  ]);
  const [searchingAssignments, setSearchingAssignments] = useState(false);

  const fetchGeographicalData = useCallback(
    async (apiEndpoint, searchTerm = "") => {
      try {
        const response = await AxiosClient.get(
          `${process.env.REACT_APP_API_URL}/api${apiEndpoint}`,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            },
            params: searchTerm ? { search: searchTerm } : {},
          }
        );
        return response.data?.data || [];
      } catch (error) {
        console.error("Error fetching geographical data:", error);
        return [];
      }
    },
    []
  );

  const handleAssignedToSearch = useCallback(
    async (searchTerm) => {
      const apiEndpoint = ROLE_API_MAPPING[userType];
      if (!apiEndpoint) {
        return;
      }

      setSearchingAssignments(true);
      try {
        const data = await fetchGeographicalData(apiEndpoint, searchTerm);
        const filteredData = data.filter((item) =>
          (item.name || item.label || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        );

        setAssignedToOptions([
          { label: "Select Assignment", value: "", isPlaceholder: true },
          ...filteredData.map((item) => ({
            label: item.name || item.label || item.value,
            value: item.id || item.value,
          })),
        ]);
      } catch (error) {
        console.error("Error searching assignments:", error);
        setAssignedToOptions([
          {
            label: "Error loading assignments",
            value: "",
            isPlaceholder: true,
          },
        ]);
      } finally {
        setSearchingAssignments(false);
      }
    },
    [userType, fetchGeographicalData]
  );

  useEffect(() => {
    const apiEndpoint = ROLE_API_MAPPING[userType];

    if (userType && apiEndpoint) {
      setSearchingAssignments(true);
      fetchGeographicalData(apiEndpoint)
        .then((data) => {
          setAssignedToOptions([
            { label: "Select Assignment", value: "", isPlaceholder: true },
            ...data.map((item) => ({
              label: item.name || item.label || item.value,
              value: item.id || item.value,
            })),
          ]);
        })
        .catch(() => {
          setAssignedToOptions([
            {
              label: "Error loading assignments",
              value: "",
              isPlaceholder: true,
            },
          ]);
        })
        .finally(() => {
          setSearchingAssignments(false);
        });
    } else {
      setAssignedToOptions([
        { label: "Select Role first", value: "", isPlaceholder: true },
      ]);
    }
  }, [userType, fetchGeographicalData]);

  return {
    assignedToOptions,
    searchingAssignments,
    handleAssignedToSearch,
  };
};
